import { render, staticRenderFns } from "./gin-cocktail.vue?vue&type=template&id=f1b48248"
import script from "./gin-cocktail.vue?vue&type=script&lang=js"
export * from "./gin-cocktail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports